import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import './KnowledgeBase.css';

const KnowledgeBase = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    category: '',
    search: '',
    page: 1,
    page_size: 20
  });
  const [totalCount, setTotalCount] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    content: '',
    tags: ''
  });

  // 生成模拟知识库数据
  const generateMockArticles = () => {
    const mockArticles = [
      {
        id: 1,
        title: '如何重置密码',
        category: 'account',
        content: '用户可以通过以下步骤重置密码：1. 点击登录页面的"忘记密码"链接 2. 输入注册邮箱 3. 查收邮件并点击重置链接 4. 设置新密码',
        tags: ['密码', '重置', '账户'],
        status: 'published',
        view_count: 156,
        created_at: '2025-01-15T10:30:00Z',
        updated_at: '2025-01-15T10:30:00Z',
        author: '客服小王'
      },
      {
        id: 2,
        title: '支付问题解决方案',
        category: 'payment',
        content: '如果遇到支付问题，请尝试以下解决方案：1. 检查网络连接 2. 清除浏览器缓存 3. 更换支付方式 4. 联系客服',
        tags: ['支付', '问题', '解决'],
        status: 'published',
        view_count: 89,
        created_at: '2025-01-14T15:20:00Z',
        updated_at: '2025-01-15T09:15:00Z',
        author: '技术小李'
      },
      {
        id: 3,
        title: '功能使用指南',
        category: 'feature',
        content: '本系统提供以下主要功能：1. 模拟面试 2. 简历诊断 3. 职业规划 4. 技能评估。每个功能都有详细的使用说明。',
        tags: ['功能', '使用', '指南'],
        status: 'published',
        view_count: 234,
        created_at: '2025-01-13T14:45:00Z',
        updated_at: '2025-01-15T11:30:00Z',
        author: '产品经理'
      },
      {
        id: 4,
        title: '常见问题FAQ',
        category: 'faq',
        content: 'Q: 如何联系客服？A: 可以通过工单系统或在线客服联系我们。Q: 服务时间？A: 7x24小时在线服务。',
        tags: ['FAQ', '常见问题', '客服'],
        status: 'published',
        view_count: 178,
        created_at: '2025-01-12T16:10:00Z',
        updated_at: '2025-01-12T16:10:00Z',
        author: '客服小王'
      },
      {
        id: 5,
        title: '系统维护通知',
        category: 'notice',
        content: '系统将于每周日凌晨2:00-4:00进行例行维护，期间可能影响部分功能使用，请提前做好准备。',
        tags: ['维护', '通知', '系统'],
        status: 'draft',
        view_count: 45,
        created_at: '2025-01-11T11:25:00Z',
        updated_at: '2025-01-14T17:45:00Z',
        author: '技术小李'
      }
    ];

    // 根据筛选条件过滤数据
    let filteredArticles = mockArticles;
    
    if (filters.category) {
      filteredArticles = filteredArticles.filter(article => article.category === filters.category);
    }
    
    if (filters.search) {
      filteredArticles = filteredArticles.filter(article => 
        article.title.toLowerCase().includes(filters.search.toLowerCase()) ||
        article.content.toLowerCase().includes(filters.search.toLowerCase()) ||
        article.tags.some(tag => tag.toLowerCase().includes(filters.search.toLowerCase()))
      );
    }

    // 设置总数
    setTotalCount(filteredArticles.length);

    // 分页处理
    const startIndex = (filters.page - 1) * filters.page_size;
    const endIndex = startIndex + filters.page_size;
    
    return filteredArticles.slice(startIndex, endIndex);
  };

  useEffect(() => {
    loadArticles();
  }, [filters]);

  const loadArticles = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // 使用模拟数据
      const mockData = generateMockArticles();
      setArticles(mockData);
      
      // 模拟API调用延迟
      await new Promise(resolve => setTimeout(resolve, 500));
      
    } catch (err) {
      console.error('Error loading articles:', err);
      setError('加载知识库失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      page: 1 // 重置页码
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({
      ...prev,
      page: newPage
    }));
  };

  const handleCreateArticle = () => {
    setFormData({
      title: '',
      category: '',
      content: '',
      tags: ''
    });
    setShowCreateModal(true);
  };

  const handleEditArticle = (article) => {
    setFormData({
      title: article.title,
      category: article.category,
      content: article.content,
      tags: article.tags.join(', ')
    });
    setSelectedArticle(article);
    setShowEditModal(true);
  };

  const handleSubmitArticle = async () => {
    if (!formData.title.trim() || !formData.content.trim()) {
      alert('请填写标题和内容');
      return;
    }

    try {
      // 模拟提交文章
      
      // 模拟API调用延迟
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setShowCreateModal(false);
      setShowEditModal(false);
      setFormData({
        title: '',
        category: '',
        content: '',
        tags: ''
      });
      setSelectedArticle(null);
      
      // 重新加载数据
      loadArticles();
      
      alert(selectedArticle ? '文章更新成功' : '文章创建成功');
    } catch (error) {
      console.error('Submit article error:', error);
      alert('操作失败');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getCategoryLabel = (category) => {
    const labels = {
      account: '账户相关',
      payment: '支付相关',
      feature: '功能使用',
      faq: '常见问题',
      notice: '系统通知'
    };
    return labels[category] || category;
  };

  const getCategoryColor = (category) => {
    const colors = {
      account: '#4299e1',
      payment: '#48bb78',
      feature: '#ed8936',
      faq: '#9f7aea',
      notice: '#f56565'
    };
    return colors[category] || '#718096';
  };

  if (loading) {
    return (
      <PageContainer>
        <LoadingContainer>
          <LoadingText>加载中...</LoadingText>
        </LoadingContainer>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>知识库管理</PageTitle>
        <HeaderActions>
          <CreateButton onClick={handleCreateArticle}>
            ➕ 新建文章
          </CreateButton>
          <RefreshButton onClick={loadArticles}>
            🔄 刷新
          </RefreshButton>
        </HeaderActions>
      </PageHeader>

      {/* 统计卡片 */}
      <StatsSection>
        <StatCard>
          <StatValue>156</StatValue>
          <StatLabel>总文章</StatLabel>
        </StatCard>
        <StatCard>
          <StatValue>142</StatValue>
          <StatLabel>已发布</StatLabel>
        </StatCard>
        <StatCard>
          <StatValue>14</StatValue>
          <StatLabel>草稿</StatLabel>
        </StatCard>
        <StatCard>
          <StatValue>2,456</StatValue>
          <StatLabel>总浏览量</StatLabel>
        </StatCard>
      </StatsSection>

      {/* 筛选和搜索 */}
      <ControlSection>
        <FiltersRow>
          <SearchInput
            type="text"
            placeholder="搜索文章标题、内容或标签..."
            value={filters.search}
            onChange={(e) => handleFilterChange('search', e.target.value)}
          />
          <FilterSelect 
            value={filters.category} 
            onChange={(e) => handleFilterChange('category', e.target.value)}
          >
            <option value="">全部分类</option>
            <option value="account">账户相关</option>
            <option value="payment">支付相关</option>
            <option value="feature">功能使用</option>
            <option value="faq">常见问题</option>
            <option value="notice">系统通知</option>
          </FilterSelect>
        </FiltersRow>
      </ControlSection>

      {/* 文章列表 */}
      {error ? (
        <ErrorMessage>{error}</ErrorMessage>
      ) : (
        <ArticlesGrid>
          {articles.map(article => (
            <ArticleCard key={article.id}>
              <ArticleHeader>
                <ArticleTitle>{article.title}</ArticleTitle>
                <CategoryBadge category={article.category}>
                  {getCategoryLabel(article.category)}
                </CategoryBadge>
              </ArticleHeader>
              
              <ArticleContent>
                {article.content.length > 100 
                  ? article.content.substring(0, 100) + '...'
                  : article.content
                }
              </ArticleContent>
              
              <ArticleTags>
                {article.tags.map((tag, index) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
              </ArticleTags>
              
              <ArticleMeta>
                <MetaItem>
                  <MetaLabel>作者：</MetaLabel>
                  {article.author}
                </MetaItem>
                <MetaItem>
                  <MetaLabel>浏览：</MetaLabel>
                  {article.view_count}
                </MetaItem>
                <MetaItem>
                  <MetaLabel>更新：</MetaLabel>
                  {formatDate(article.updated_at)}
                </MetaItem>
              </ArticleMeta>
              
              <ArticleActions>
                <ActionButton 
                  onClick={() => handleEditArticle(article)}
                >
                  编辑
                </ActionButton>
                <ActionButton 
                  onClick={() => {}}
                >
                  查看
                </ActionButton>
              </ArticleActions>
            </ArticleCard>
          ))}
        </ArticlesGrid>
      )}

      {/* 分页 */}
      {totalCount > filters.page_size && (
        <PaginationSection>
          <PaginationInfo>
            显示 {((filters.page - 1) * filters.page_size) + 1} - {Math.min(filters.page * filters.page_size, totalCount)} 条，
            共 {totalCount} 条
          </PaginationInfo>
          <PaginationButtons>
            <PaginationButton 
              onClick={() => handlePageChange(filters.page - 1)}
              disabled={filters.page === 1}
            >
              上一页
            </PaginationButton>
            <PaginationButton 
              onClick={() => handlePageChange(filters.page + 1)}
              disabled={filters.page * filters.page_size >= totalCount}
            >
              下一页
            </PaginationButton>
          </PaginationButtons>
        </PaginationSection>
      )}

      {/* 创建/编辑文章弹框 */}
      {(showCreateModal || showEditModal) && (
        <ModalOverlay onClick={() => {
          setShowCreateModal(false);
          setShowEditModal(false);
        }}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>
                {showCreateModal ? '新建文章' : '编辑文章'}
              </ModalTitle>
              <CloseButton onClick={() => {
                setShowCreateModal(false);
                setShowEditModal(false);
              }}>×</CloseButton>
            </ModalHeader>
            
            <ModalBody>
              <FormGroup>
                <Label>文章标题</Label>
                <Input
                  value={formData.title}
                  onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
                  placeholder="请输入文章标题..."
                />
              </FormGroup>
              
              <FormGroup>
                <Label>分类</Label>
                <Select
                  value={formData.category}
                  onChange={(e) => setFormData(prev => ({ ...prev, category: e.target.value }))}
                >
                  <option value="">请选择分类</option>
                  <option value="account">账户相关</option>
                  <option value="payment">支付相关</option>
                  <option value="feature">功能使用</option>
                  <option value="faq">常见问题</option>
                  <option value="notice">系统通知</option>
                </Select>
              </FormGroup>
              
              <FormGroup>
                <Label>文章内容</Label>
                <TextArea
                  value={formData.content}
                  onChange={(e) => setFormData(prev => ({ ...prev, content: e.target.value }))}
                  placeholder="请输入文章内容..."
                  rows={8}
                />
              </FormGroup>
              
              <FormGroup>
                <Label>标签（用逗号分隔）</Label>
                <Input
                  value={formData.tags}
                  onChange={(e) => setFormData(prev => ({ ...prev, tags: e.target.value }))}
                  placeholder="例如：密码, 重置, 账户"
                />
              </FormGroup>
            </ModalBody>
            
            <ModalFooter>
              <CancelButton onClick={() => {
                setShowCreateModal(false);
                setShowEditModal(false);
              }}>
                取消
              </CancelButton>
              <SubmitButton onClick={handleSubmitArticle}>
                {showCreateModal ? '创建文章' : '更新文章'}
              </SubmitButton>
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      )}
    </PageContainer>
  );
};

export default KnowledgeBase;

// 样式组件
const PageContainer = styled.div`
  padding: 24px;
  background: #f8fafc;
  min-height: 100vh;
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
`;

const CreateButton = styled.button`
  padding: 8px 16px;
  background: #48bb78;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;

const RefreshButton = styled.button`
  padding: 8px 16px;
  background: white;
  color: #667eea;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8fafc;
    border-color: #667eea;
  }
`;

const StatsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

const StatCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const StatValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 4px;
`;

const StatLabel = styled.div`
  font-size: 14px;
  color: #718096;
`;

const ControlSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const FiltersRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SearchInput = styled.input`
  flex: 2;
  padding: 12px 16px;
  border: 2px solid #f1f5f9;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

const FilterSelect = styled.select`
  flex: 1;
  padding: 12px 16px;
  border: 2px solid #f1f5f9;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  cursor: pointer;
`;

const ArticlesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
`;

const ArticleCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

const ArticleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

const ArticleTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  flex: 1;
  line-height: 1.4;
`;

const CategoryBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  background: ${props => {
    const colors = {
      account: '#4299e1',
      payment: '#48bb78',
      feature: '#ed8936',
      faq: '#9f7aea',
      notice: '#f56565'
    };
    return colors[props.category] || '#718096';
  }};
  white-space: nowrap;
  margin-left: 12px;
`;

const ArticleContent = styled.div`
  font-size: 14px;
  color: #4a5568;
  line-height: 1.6;
  margin-bottom: 12px;
`;

const ArticleTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
`;

const Tag = styled.span`
  padding: 2px 8px;
  background: #f1f5f9;
  color: #4a5568;
  border-radius: 4px;
  font-size: 12px;
`;

const ArticleMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

const MetaItem = styled.div`
  font-size: 12px;
  color: #718096;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const MetaLabel = styled.span`
  font-weight: 500;
`;

const ArticleActions = styled.div`
  display: flex;
  gap: 8px;
`;

const ActionButton = styled.button`
  padding: 6px 12px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

const PaginationSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 16px;
  background: white;
  border-radius: 8px;
`;

const PaginationInfo = styled.div`
  font-size: 14px;
  color: #718096;
`;

const PaginationButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const PaginationButton = styled.button`
  padding: 8px 16px;
  background: white;
  color: #667eea;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  
  &:hover:not(:disabled) {
    background: #f8fafc;
    border-color: #667eea;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// 弹框样式
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 24px;
`;

const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f1f5f9;
    color: #334155;
  }
`;

const ModalBody = styled.div`
  padding: 0 24px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #f1f5f9;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  color: #374151;
  background: white;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  color: #374151;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  color: #374151;
  background: white;
  resize: vertical;
  min-height: 200px;
  font-family: inherit;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

const CancelButton = styled.button`
  padding: 12px 24px;
  background: white;
  color: #64748b;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
    color: #374151;
  }
`;

const SubmitButton = styled.button`
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const LoadingContainer = styled.div`
  text-align: center;
  padding: 60px 20px;
`;

const LoadingText = styled.div`
  color: #718096;
  font-size: 14px;
`;

const ErrorMessage = styled.div`
  background: #fff5f5;
  color: #c53030;
  padding: 16px 20px;
  border-radius: 8px;
  border: 1px solid #feb2b2;
  font-size: 14px;
  margin-bottom: 20px;
`;
